import { useState, useRef } from "react";
import { useRouter } from "next/router";
import FaqIcon from "../../../public/remove_back/magic_bg/faq_icon.svg";
import style from "../MagicBgForm/MagicBgForm.module.scss";
import useClickOutside from "../../../utils/hooks/useClickOutside";

const getDictionaryName = (name) => {
	switch (name) {
		case "negative":
			return "tutorial_negative_prompt";
		case "seed":
			return "tutorial_seed";
		case "sampler":
			return "tutorial_sampler";
		case "steps":
			return "tutorial_steps";
		default:
			name;
	}
};

{
	/* <a href='#negative' target='_blank'>фраза</a>
<a href='#seed' target='_blank'>фраза</a>
<a href='#sampler' target='_blank'>фраза</a>
<a href='#steps' target='_blank'>фраза</a> */
}

function HelpWindow({ dictionary, name }) {
	const messageRef = useRef(null);
	const [showMessage, setShowMessage] = useState(false);

	const router = useRouter();

	useClickOutside(messageRef, () => {
		setShowMessage(false);
	});

	const handleRouterChange = (e) => {
		if (e?.target?.tagName?.toLowerCase() === "a") {
			router.push("/" + router.locale + router.asPath + "#" + name);
		}
	};

	return (
		<>
			<button
				onClick={() => {
					setShowMessage(true);
				}}
				className={style.faqBtn}
			>
				<FaqIcon className={style.faqIcon} />
			</button>
			{showMessage && (
				<div
					onClick={handleRouterChange}
					ref={messageRef}
					className={style.faqMessage}
					dangerouslySetInnerHTML={{
						__html: `${dictionary[getDictionaryName(name)].replace(`#${name}`, "/" + router.locale + router.asPath + "#" + name) || name}`,
					}}
				></div>
			)}
		</>
	);
}

export default HelpWindow;
